import { render, staticRenderFns } from "./StoriesArticleOverlapImg.vue?vue&type=template&id=736aa12a&scoped=true&"
import script from "./StoriesArticleOverlapImg.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleOverlapImg.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleOverlapImg.vue?vue&type=style&index=0&id=736aa12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736aa12a",
  null
  
)

export default component.exports